import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  walletAccountApi,
  walletContractApi,
  walletTransactionApi,
} from "../../Services/Payments/PaymentApi";

export const walletAccount = createAsyncThunk(
  "walletAccount/get",
  async ({ role, id }) => {
    try {
      let data = await walletAccountApi({ role, id });
      return data;
    } catch (err) {}
  },
);

export const walletTransaction = createAsyncThunk(
  "transaction/get",
  async ({ page, size }) => {
    try {
      let data = await walletTransactionApi({ page, size });
      return data;
    } catch (err) {}
  },
);

export const walletContract = createAsyncThunk(
  "walletContract/get",
  async ({ id, page, size }) => {
    try {
      let data = await walletContractApi({ id, page, size });
      return data;
    } catch (err) {}
  },
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {},
  reducers: {
    clearWalletContract: (state) => {
      state.walletContract = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(walletAccount.pending, (state) => {})
      .addCase(walletAccount.fulfilled, (state, action) => {
        state.walletAccountActive =
          action.payload?.data?.data?.walletAccounts?.[0];
        state.walletAccountAll = action.payload?.data?.data?.walletAccounts;
      })
      .addCase(walletAccount.rejected, (state, action) => {});
    builder
      .addCase(walletTransaction.pending, (state) => {
        state.walletTransactionLoading = true;
      })
      .addCase(walletTransaction.fulfilled, (state, action) => {
        state.walletTransaction = action.payload?.data?.data?.page;
        state.walletTransactionLoading = false;
      })
      .addCase(walletTransaction.rejected, (state, action) => {
        state.walletTransactionLoading = false;
      });
    builder
      .addCase(walletContract.pending, (state) => {
        state.walletContractLoading = true;
      })
      .addCase(walletContract.fulfilled, (state, action) => {
        state.walletContract = action.payload?.data?.data?.page;
        state.walletContractLoading = false;
      })
      .addCase(walletContract.rejected, (state, action) => {
        state.walletContractLoading = false;
      });
  },
});

export const { clearWalletContract } = paymentSlice.actions;
export default paymentSlice.reducer;
